/* eslint-disable indent */
import moment from 'moment';
import apis from 'src/const/apis';
import * as types from 'src/store/types';
import request from 'src/utils/request';
import reportDownload from 'src/utils/report-download';
import {
  defaultFilters, dateTypesMap, summaryDataMap, newTransactionTypeMap, paymentsTypeMap,
  transactionTabType, transactionStatusMap,
} from 'src/const/transaction';
import tool from 'src/utils/tool';
import { Message } from 'byted-vui';
import { i18n } from 'src/utils/localeUtil';

const { aadvid } = tool.queryToJson();
const UI_DATE_FORMAT = 'YYYYMM';
const FULL_DAY_FORMAT = 'YYYY-MM-DD';
const MONTH_FORMAT = 'YYYY-MM';
const TRANSACTION_NOT_BEFORE = '2019-03-01';

function getParams(params = {}, isDownLoad = false) {
  return {
    ...params,
    action: !isDownLoad ? '' : 'download',
  };
}

function getCommonNewTransactionDataListConfig() {
  return {
    list: [],
    amount: '0',
    currency: '',
  };
}

export default {
  namespaced: true,
  state: {
    allDeposit: 0,
    allTransfer: 0,
    transactions: [],
    monthsData: {},
    listLoading: true,
    invoiceLoading: false,
    listExporting: false,
    transactionType: defaultFilters.transactionType,
    dateType: defaultFilters.dateType,
    requestParams: {
      aadvid,
      st: '',
      et: '',
    },
    newTransactionListLoading: true,
    newTransactionCostsListLoading: false,
    newTransactionDownloadLoading: false,
    newTransactionPaymentsLoading: false,
    summaryData: {
      [summaryDataMap.campaignCosts]: 0,
      [summaryDataMap.payments]: 0,
      [summaryDataMap.promotions]: 0,
      [summaryDataMap.adjustments]: 0,
    },
    costsPagination: {
      page: 1,
      limit: 20,
      total: 0,
    },
    listData: {
      [newTransactionTypeMap.payments]: {
        [paymentsTypeMap.payments]: getCommonNewTransactionDataListConfig(),
        [paymentsTypeMap.promotions]: getCommonNewTransactionDataListConfig(),
        [paymentsTypeMap.adjustments]: getCommonNewTransactionDataListConfig(),
      },
      [newTransactionTypeMap.costs]: {
        default: getCommonNewTransactionDataListConfig(),
      },
      [newTransactionTypeMap.tax]: {
        default: getCommonNewTransactionDataListConfig(),
      },
    },
    currentTabType: transactionTabType.payments,
  },
  mutations: {
    [types.SET_TRANSACTION_DATA](state, data) {
      state.transactions = data.transactions || [];
      state.allDeposit = data.charge_total || 0;
      state.monthsData = data.monthly_stat || 0;
      state.allTransfer = (data.cost_total || 0) + (data.tax_total || 0);
    },
    [types.SET_TRANSACTION_LIST_LOADING](state, isLoading) {
      state.listLoading = isLoading;
    },
    [types.SET_INVOICE_LOADING](state, isLoading) {
      state.invoiceLoading = isLoading;
    },
    [types.SET_TRANSACTION_LIST_EXPORTING](state, isExporting) {
      state.listExporting = isExporting;
    },
    [types.SET_TRANSACTION_TYPE](state, type) {
      state.transactionType = type;
    },
    [types.SET_TRANSACTION_DATE_TYPE](state, type) {
      state.dateType = type;
    },
    [types.SET_NEW_TRANSACTION_LIST_REQUEST_PARAMS](state, data = {}) {
      state.requestParams = {
        ...state.requestParams,
        ...data,
      };
    },
    [types.SET_NEW_TRANSACTION_COST_PAGINATION_PARAMS](state, data = {}) {
      state.costsPagination = {
        ...state.costsPagination,
        ...data,
      };
    },
    [types.SET_NEW_TRANSACTION_LIST_LOADING](state, isLoading = false) {
      state.newTransactionListLoading = isLoading;
    },
    [types.SET_NEW_TRANSACTION_COSTS_LIST_LOADING](state, isLoading = false) {
      state.newTransactionCostsListLoading = isLoading;
    },
    [types.SET_NEW_TRANSACTION_DOWNLOAD_LOADING](state, isLoading = false) {
      state.newTransactionDownloadLoading = isLoading;
    },
    [types.SET_NEW_TRANSACTION_PAYMENTS_LOADING](state, isLoading = false) {
      state.newTransactionPaymentsLoading = isLoading;
    },
    [types.SET_NEW_TRANSACTION_SUMMARY_DATA](state, data = {}) {
      state.summaryData = {
        ...state.summaryData,
        ...data,
      };
    },
    [types.SET_NEW_TRANSACTION_LIST_DATA](state, {
      type = newTransactionTypeMap.payments,
      subType = 'default',
      data = getCommonNewTransactionDataListConfig(),
    }) {
      state.listData[type][subType] = data;
    },
    [types.SET_NEW_TRANSACTION_CURRENT_TAB_TYPE](state, currentTabType = transactionTabType.payments) {
      state.currentTabType = currentTabType;
    },
  },
  getters: {
    queryDate: (state) => { // 20190102
      const currentMonthMo = moment();
      const currentEndDate = currentMonthMo.format(FULL_DAY_FORMAT);
      const currentMonth = currentMonthMo.month();

      const lastMonthMo = moment().month(currentMonth - 1);
      const last3MonthMo = moment().month(currentMonth - 2);
      const last6MonthMo = moment().month(currentMonth - 5);
      const currentYearMo = moment().startOf('year');
      const last12MonthMo = moment().month(currentMonth - 11);
      const allTimeMo = moment(TRANSACTION_NOT_BEFORE);

      switch (state.dateType) {
        case dateTypesMap.CURRENT_MONTH:
          return {
            startDate: currentMonthMo.startOf('month').format(FULL_DAY_FORMAT),
            endDate: currentEndDate,
          };
        case dateTypesMap.PREVIOUS_MONTH:
          return {
            startDate: lastMonthMo.startOf('month').format(FULL_DAY_FORMAT),
            endDate: lastMonthMo.endOf('month').format(FULL_DAY_FORMAT),
          };
        case dateTypesMap.LAST_3_MONTH:
          return {
            startDate: last3MonthMo.startOf('month').format(FULL_DAY_FORMAT),
            endDate: currentEndDate,
          };
        case dateTypesMap.LAST_6_MONTH:
          return {
            startDate: last6MonthMo.startOf('month').format(FULL_DAY_FORMAT),
            endDate: currentEndDate,
          };
        case dateTypesMap.THIS_YEAR:
          return {
            startDate: currentYearMo.startOf('month').format(FULL_DAY_FORMAT),
            endDate: currentEndDate,
          };
        case dateTypesMap.LAST_12_MONTH:
          return {
            startDate: last12MonthMo.startOf('month').format(FULL_DAY_FORMAT),
            endDate: currentEndDate,
          };
        case dateTypesMap.ALL_TIME:
          return {
            startDate: allTimeMo.startOf('month').format(FULL_DAY_FORMAT),
            endDate: currentEndDate,
          };
        default:
          return {
            startDate: currentMonthMo.startOf('month').format(FULL_DAY_FORMAT),
            endDate: currentEndDate,
          };
      }
    },
    monthRange: (state, getters) => {
      let { startDate } = getters.queryDate;
      const { endDate } = getters.queryDate;
      if (state.dateType === dateTypesMap.ALL_TIME) { // 用户选择了所有时间
        const { transactions = [] } = state;
        if (!transactions.length) return []; // 若无交易记录 返回空
        startDate = transactions[transactions.length - 1].transaction_date || startDate;
      }

      const res = [];
      const end = moment(endDate);
      const endYearMonth = moment(end.format(MONTH_FORMAT));

      for (
        let start = moment(startDate);
        moment(start.format(MONTH_FORMAT)).isBefore(endYearMonth);
        start.add(1, 'month')
      ) {
        const daysInMonth = start.daysInMonth();
        res.unshift({
          yearMonth: start.format(UI_DATE_FORMAT),
          year: start.year(),
          month: start.month() + 1,
          days: daysInMonth,
          startDay: 1,
          endDay: daysInMonth,
        });
      }
      res.unshift({ // 处理最后一个月
        yearMonth: end.format(UI_DATE_FORMAT),
        year: end.year(),
        month: end.month() + 1,
        days: end.daysInMonth(),
        startDay: 1,
        endDay: end.date(),
      });

      return res;
    },
    transactionData: (state, getters) => {
      const { monthsData = {}, transactions = [] } = state;
      const transMap = transactions.reduce((res, item) => { // 将交易列表按月group
        const yearMonth = moment(item.transaction_date).format(UI_DATE_FORMAT);
        res[yearMonth] = res[yearMonth] || [];
        res[yearMonth].push(item);
        return res;
      }, {});

      return getters.monthRange.map((item) => {
        const monthData = monthsData[item.yearMonth] || {};
        const chargeTotal = monthData.charge_total || 0;
        const costTotal = monthData.cost_total || 0;
        const taxTotal = monthData.tax_total || 0;
        const count = monthData.total_count || 0;
        const amount = chargeTotal - costTotal - taxTotal;

        return {
          items: transMap[item.yearMonth] || [],
          monthData: {
            chargeTotal, costTotal, taxTotal, count, amount,
          },
          ...item,
        };
      });
    },
    paymentsData: state => state.listData[newTransactionTypeMap.payments][paymentsTypeMap.payments],
    promotionsData: state => state.listData[newTransactionTypeMap.payments][paymentsTypeMap.promotions],
    adjustmentsData: state => state.listData[newTransactionTypeMap.payments][paymentsTypeMap.adjustments],
    costsData: state => state.listData[newTransactionTypeMap.costs].default,
    taxData: state => state.listData[newTransactionTypeMap.tax].default,
    pageNoDataConfig: ({ listData }) => Object.keys(listData).reduce((obj, key) => {
        obj[key] = Object.values(listData[key]).every(t => !t?.list?.length);
        return obj;
    }, {}),
    disabledDownload(state, getters) {
      const { pageNoDataConfig } = getters;
      const { currentTabType } = state;
      if (currentTabType === transactionTabType.payments) {
        return !!pageNoDataConfig?.[transactionTabType.payments];
      }
      return !!(pageNoDataConfig[newTransactionTypeMap.costs] && pageNoDataConfig[newTransactionTypeMap.tax]);
    },
  },
  actions: {
    getInvoice({ commit }, data) {
      commit(types.SET_INVOICE_LOADING, true);

      // 错误处理
      const failureCheckFunc = (responseObj) => {
        if (responseObj.code !== 0) {
            Message.error(i18n.t(responseObj?.msg || 'module_transaction_download_fail_no_content'));
            return true;
        }
        return false;
      };

      return new Promise((resolve, reject) => {
        const api = apis.transaction.new_invoice;
      reportDownload(data, api, '', '', { failureCheckFunc }, 'GET')
      .then((res) => {
          commit(types.SET_INVOICE_LOADING, false);
          resolve(res);
        }).catch((err) => {
          commit(types.SET_INVOICE_LOADING, false);
          reject(err);
        });
      });
    },
    async getTransactions({ commit, state, getters }, waitTime = 0) {
      commit(types.SET_TRANSACTION_LIST_LOADING, true);
      commit(types.SET_TRANSACTION_DATA, {});
      const { queryDate } = getters;
      const transactionList = apis.transaction.newList;
      if (waitTime) {
        await new Promise((resolve) => {
          setTimeout(() => {
            resolve();
          }, waitTime);
        });
      }
      request
        .get(transactionList, {
          aadvid,
          query_types: `[${(state.transactionType || '').split(',')}]`,
          start_time: queryDate.startDate,
          end_time: queryDate.endDate,
        })
        .then((res = {
          charge_total: 0,
          cost_total: 0,
          tax_total: 0,
          monthly_stat: {},
          transactions: [],
        }) => {
          if (res.data) {
            commit(types.SET_TRANSACTION_LIST_LOADING, false);
            commit(types.SET_TRANSACTION_DATA, res.data);
          } else {
            commit(types.SET_TRANSACTION_LIST_LOADING, false);
          }
        })
        .catch((err) => {
          commit(types.SET_TRANSACTION_LIST_LOADING, false);
        });
    },
    exportTransactions({ commit, getters, state }) {
      commit(types.SET_TRANSACTION_LIST_EXPORTING, true);

      const { queryDate } = getters;
      const requestParams = {
        aadvid,
        query_types: `[${(state.transactionType || '').split(',')}]`,
        start_time: queryDate.startDate,
        end_time: queryDate.endDate,
      };
      const transactionExport = apis.transaction.newExport;
      const transactionDownload = apis.transaction.newDownLoad;

      return new Promise((resolve, reject) => {
        reportDownload(requestParams, transactionExport, transactionDownload)
          .then((res) => {
            commit(types.SET_TRANSACTION_LIST_EXPORTING, false);
            resolve(res);
          })
          .catch((err) => {
            commit(types.SET_TRANSACTION_LIST_EXPORTING, false);
            reject(err);
          });
      });
    },
    // 获取payments列表数据
    async getPaymentsList({ commit, state }, waitTime = 0) {
      if (waitTime) {
        commit(types.SET_NEW_TRANSACTION_PAYMENTS_LOADING, true);
        await new Promise((resolve) => {
          setTimeout(() => {
            resolve();
            commit(types.SET_NEW_TRANSACTION_PAYMENTS_LOADING, false);
          }, waitTime);
        });
      }
      return request
        .get(apis.transaction.paymentsList, getParams(state.requestParams))
        .then(({ data }) => {
          if (data) {
            const {
              table = [],
              pagination: {
                top_up_count = 0,
                promotions_count = 0,
                adjustments_count = 0,
              },
              statistics: {
                top_up_amount = '0',
                promotions_amount = '0',
                adjustments_amount = '0',
                currency = '',
              },
            } = data;
            commit(types.SET_NEW_TRANSACTION_SUMMARY_DATA, {
              [summaryDataMap.payments]: top_up_count ?? 0,
              [summaryDataMap.promotions]: promotions_count ?? 0,
              [summaryDataMap.adjustments]: adjustments_count ?? 0,
            });

            const paymentsDataMap = {
              [paymentsTypeMap.payments]: {
                amount: String(top_up_amount),
                list: [],
                currency,
              },
              [paymentsTypeMap.promotions]: {
                amount: String(promotions_amount),
                list: [],
                currency,
              },
              [paymentsTypeMap.adjustments]: {
                amount: String(adjustments_amount),
                list: [],
                currency,
              },
            };
            table.forEach((item) => {
              // pending handling 这两种状态转换为前端状态processing统一展示
              if ([transactionStatusMap.pending, transactionStatusMap.handling].includes(item.transaction_status)) {
                item.transaction_status = transactionStatusMap.processing;
              }
              paymentsDataMap[item.transaction_type].list.push(item);
            });

            Object.keys(paymentsDataMap).forEach((key) => {
              commit(types.SET_NEW_TRANSACTION_LIST_DATA, {
                type: newTransactionTypeMap.payments,
                subType: key,
                data: paymentsDataMap[key],
              });
            });
          }
        });
    },
    // 获取costs列表数据
    getCostsList({ commit, state }) {
      commit(types.SET_NEW_TRANSACTION_COSTS_LIST_LOADING, true);
      return request.get(apis.transaction.costsList, {
        ...getParams(state.requestParams),
        ...state.costsPagination,
      }).then(({ data }) => {
        if (data) {
          const {
            table = [],
            pagination: {
              total_count = 0,
            },
            statistics: {
              amount = '0',
              currency = '',
            },
          } = data;
          commit(types.SET_NEW_TRANSACTION_COST_PAGINATION_PARAMS, {
            total: Number(total_count),
          });
          commit(types.SET_NEW_TRANSACTION_LIST_DATA, {
            type: newTransactionTypeMap.costs,
            data: {
              list: table || [],
              amount: String(amount),
              currency,
            },
          });

          commit(types.SET_NEW_TRANSACTION_SUMMARY_DATA, {
            [summaryDataMap.campaignCosts]: total_count ?? 0,
          });
        }
      }).finally(() => {
        commit(types.SET_NEW_TRANSACTION_COSTS_LIST_LOADING, false);
      });
    },
    // 获取tax列表数据
    getTaxList({ commit, state }) {
      return request.get(apis.transaction.taxList, getParams(state.requestParams)).then(({ data }) => {
        if (data) {
          const { table, statistics: { tax_amount = '0', currency = '' } } = data;
          commit(types.SET_NEW_TRANSACTION_LIST_DATA, {
            type: newTransactionTypeMap.tax,
            data: {
              list: table,
              currency,
              amount: String(tax_amount),
            },
          });
        }
      });
    },
    getNewTransactionList({ dispatch, commit }) {
      commit(types.SET_NEW_TRANSACTION_LIST_LOADING, true);
      return Promise.all([
        dispatch('getPaymentsList'),
        dispatch('getCostsList'),
        dispatch('getTaxList'),
      ]).finally(() => {
        commit(types.SET_NEW_TRANSACTION_LIST_LOADING, false);
      });
    },
    downloadReport({ commit, state, getters }) {
      if (getters.disabledDownload) return;
      commit(types.SET_NEW_TRANSACTION_DOWNLOAD_LOADING, true);
      const { currentTabType, requestParams } = state;
      const isPayments = currentTabType === transactionTabType.payments;

      const downloadApi = apis.reporting.new_run_reporting_download_url;
      const exportApi = isPayments ? apis.transaction.paymentsList : apis.transaction.costsList;
      const params = getParams(requestParams, true);

      const tasks = [];

      if (!getters.pageNoDataConfig[currentTabType]) {
        tasks.push(reportDownload(params, exportApi, downloadApi, 'download_id', { isGetFileUrl: true }));
      }

      if (!isPayments && !getters.pageNoDataConfig[newTransactionTypeMap.tax]) {
        // 额外导出tax信息
        tasks.push(reportDownload(getParams(requestParams, true), apis.transaction.taxList, downloadApi, 'download_id', { isGetFileUrl: true }));
      }

      return Promise.all(tasks).finally(() => {
        commit(types.SET_NEW_TRANSACTION_DOWNLOAD_LOADING, false);
      });
    },
  },
};
